import { render, staticRenderFns } from "./ReturnQualityInspectionRecords.vue?vue&type=template&id=588124d7&scoped=true&"
import script from "./ReturnQualityInspectionRecords.vue?vue&type=script&lang=js&"
export * from "./ReturnQualityInspectionRecords.vue?vue&type=script&lang=js&"
import style0 from "./ReturnQualityInspectionRecords.vue?vue&type=style&index=0&id=588124d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588124d7",
  null
  
)

export default component.exports